// extracted by mini-css-extract-plugin
export default {"blockNotice":"style_blockNotice__sD2Ot","stepIndicator":"style_stepIndicator__I0G3S"};